import React, { useRef, useEffect, useState, useMemo } from 'react';
import determineStage from '@/utils/DetermineStage';
import { Menu, Dropdown, Button, Space, Tooltip, Divider, Popover, Collapse } from 'antd';
import {
  TableOutlined,
  UnorderedListOutlined,
  AppstoreOutlined,
  CalendarOutlined,
  BarChartOutlined,
  LineChartOutlined,
  FileTextOutlined,
  FileDoneOutlined,
  RocketOutlined,
  ThunderboltOutlined,
  UserOutlined,
  FilterOutlined,
  LeftOutlined,
  DownOutlined,
  EyeInvisibleOutlined,
  EyeOutlined,
  GroupOutlined,
  BgColorsOutlined,
  SortAscendingOutlined,
  HistoryOutlined,
  MenuFoldOutlined,
  SettingOutlined,
  DownloadOutlined,
  CopyOutlined,
  DatabaseOutlined,
  RotateRightOutlined,
  MenuUnfoldOutlined,
} from '@ant-design/icons';
import AttributeFilters from './getAttributeFilter';
import FilterContent from './FilterContent';
import RenderView from './RenderView';
import initialColumns from '@/utils/column/initialColumns';
import milestoneInitialColumns from '@/utils/column/milestoneInitialColumn';
import actionItemInitialColumn from '@/utils/column/actionItemInitialColumn';
import ColumnVisibileManager from '@/utils/column/visibleColumnManager';
import handleDownloadData from '@/utils/helpers/handleDownload';
import SortContent from '@/utils/Sort/sortContent';
import MilestoneSortContent from '@/utils/Sort/milestoneSortContent';
import WorkstreamActionSortContent from '@/utils/Sort/workstreamActionSortContent';
import ColorContent from '@/utils/color/ColorContent';
import MilestoneColorContent from '@/utils/color/milestoneColorContent';
import WorkstreamActionColorContent from '@/utils/color/workstreamActionColorContent';
import ImpactColorContent from '@/utils/color/impactColorContent';
import HistoryGroupContent from '@/utils/group/historyGroupContent';
import ImpactGroupContent from '@/utils/group/groupingImpactContent';
import PeriodGroupContent from '@/utils/group/periodGroupContent';
import WorkstreamActionGroupContent from '@/utils/group/workstreamActionGroupingContent';
import MilestoneGroupContent from '@/utils/group/milestoneGroupingContent';
import GroupContent from '@/utils/group/groupingContent';
import AggregateContent from '@/utils/aggregate/aggregateContent';
import checkToFinanceApprovalStatus from '@/utils/Sort/checkTOFinanceApprovalStatus';
import checkWorkstreamLeadApprovalStatus from '@/utils/Sort/checkWorkstreamLeadApprovalStatus';
import checkWorkstreamSponsorApprovalStatus from '@/utils/Sort/checkWorkstreamSponsorApprovalStatus';
import getNetRecurringBenefitCategory from '@/utils/Sort/getNetRecurringBenefitCatagory';
import InitiativePlanningSummary from '@/utils/initiativePlanningSummary';
import LLatestActualDate from '@/utils/Sort/checkDate/LLatestActualDate';
import sortInitiativesByActuals from '@/utils/Sort/sortByActual';
import sortInitiativesByActualImpact from '@/utils/Sort/sortByActualImpact';
import getImplementationCostCatagory from '@/utils/Sort/getImplementationCostCatagory';
import checkStrategyAnalystApprovalStatus from '@/utils/Sort/checkStrategyAnalystApprovalStatus';
import { determinePlanningSummary } from '@/utils/planningSummary';
import {
  L0ActualDate,
  L1ActualDate,
  L2ActualDate,
  L3ActualDate,
  L4ActualDate,
  L5ActualDate,
  SubmittedForL1PlanDate,
  SubmittedForL2PlanDate,
  SubmittedForL3PlanDate,
  SubmittedForL4PlanDate,
  SubmittedForL5PlanDate,
  L1PlanDate,
  L2PlanDate,
  L3PlanDate,
  L4PlanDate,
  L5PlanDate
} from '@/utils/Sort/checkDate/getDate';
import getNetRecurringBenefitChangeCategoryL0Plus from '@/utils/color/getNetRecurringBenefitCatagoryL0Plus';
import getNetRecurringBenefitChangeCategoryL1Plus from '@/utils/color/getNetRecurringBenefitCatagoryL1Plus';
import getNetRecurringBenefitChangeCategoryL2Plus from '@/utils/color/getNetRecurringBenefitCatagoryL2Plus';
import getNetRecurringBenefitChangeCategoryL3Plus from '@/utils/color/getNetRecurringBenefitCatagoryL3Plus';
import getNetRecurringBenefitChangeCategoryL4Plus from '@/utils/color/getNetRecurringBenefitCatagoryL4Plus';
import getComplianceStatus from '@/utils/Sort/complianceCheck';
import determineInitiativesPlanningSummary from '@/utils/filters/planningSummaryForInitiatives';
import { useHistorysData } from './DataHooks';
import calculateNetRecurringBenefit from '@/utils/calculation/calculationRecurringBenefit';
import calculateOneTimeBenefit from '@/utils/calculation/calculateOneTimeBenefit';
import calculateOneTimeImplementationCost from '@/utils/calculation/calculateOneTimeImplementationCost';
import L0PlanDate from '@/utils/Sort/checkDate/l0ActualDate';
import { getMilestoneBinValue } from '@/utils/helpers/getMilestoneBinValue';
const EXECUTIVE_ASSISTANT_ALLOWED_SOURCES = ['CMC', 'EMC', 'AMC', 'Office of CEO'];
const RESTRICTED_SOURCES = ['AMC', 'CMC', 'EMC', 'Office of CEO'];
const Workbook = ({
  initiatives,
  actionItem,
  subworkstream,
  users,
  filteredData,
  sortField,
  setSortField,
  sortOrder,
  setSortOrder,
  searchTerm,
  setSearchTerm,
  currentFilter,
  setCurrentFilter,
  impactCurrentFilter,
  setImpactCurrentFilter,
  milestoneCurrentFilter,
  setMilestoneCurrentFilter,
  kpiCurrentFilter,
  setKpiCurrentFilter,
  actionCurrentFilter,
  setActionCurrentFilter,
  attributeFilters,
  setAttributeFilters,
  filteredActionItems,
  filteredMilestones,
  selectedFilters,
  setSelectedFilters,
  groupedInitiativesByHistory,
  selectedGroup,
  setSelectedGroup,
  colorByAttribute,
  setColorByAttribute,
  initiativeColors,
  milestoneColors,
  actionItemColors,
  groupedActionItems,
  groupedMilestones,
  groupedImpact,
  selectedImpactGroup,
  setSelectedImpactGroup,
  selectedHistoryGroup,
  setSelectedHistoryGroup,
  selectedTimePeriod,
  setSelectedTimePeriod,
  periodCurrentFilter,
  setPeriodCurrentFilter,
  selectedDateRange,
  setSelectedDateRange,
  selectedRange,
  setSelectedRange,
  groupedInitiatives,
  milestones,
  filterHistory,
  setFilterHistory,
  selectedMenu,
  setSelectedMenu,
  aggregatedAttributes,
  setAggregatedAttributes,
  sumVisible,
  setSumVisible,
  finalTotal,
  selectedInfoMenu,
  setSelectedInfoMenu,
  xAxis,
  setXAxis,
  yAxis,
  setYAxis,
  setGroupedMilestones,
  setGroupedInitiatives,
  setGroupedActionItems,
  setGroupedImpact,
  setGroupedInitiativesByHistory,
  subsectors,
  currentUser
}) => {
  const historyData = useHistorysData();
  const selectedMetric = null;
  const workbookRef = useRef(null);
  const otherElementRef = useRef(null);
  const [searchResults, setSearchResults] = useState([]);
  const [groupVisible, setGroupVisible] = useState(false);
  const [colorVisible, setColorVisible] = useState(false);
  const [sortVisible, setSortVisible] = useState(false);
  const [colorFilter, setColorFilter] = useState(null);
  const [sortFilter, setSortFilter] = useState(null);
  const [cardDetailVisible, setCardDetailVisible] = useState(true);
  const [trackChangesVisible, setTrackChangesVisible] = useState(false);
  const [collapseExpandeVisible, setCollapseExpandVisible] = useState(false);
  const [swapVisible, setSwapVisible] = useState(false);
  const [tableDownloadVisible, setTableDownloadVisible] = useState(false);
  const [copyVisible, setCopyVisible] = useState(false);
  const [aggregationVisible, setAggregationVisible] = useState(false);
  const [initiativeFilterType, setInitiativeFilterType] = useState(null);
  const [groupingFilter, setGroupingFilter] = useState(null);
  const [isGroupingEnabled, setIsGroupingEnabled] = useState(false);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [filterVisible, setFilterVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const isMounted = useRef(false);
  const [expandedKeys, setExpandedKeys] = useState([]);
  const [isAllGroupsCollapsed, setIsAllGroupsCollapsed] = useState(true);
  const [isAllGroupsExpanded, setIsAllGroupsExpanded] = useState(false);
  const isExecutiveAssistant = currentUser?.role?.name === 'Executive Assistant';
  const isAdmin = currentUser?.role?.name === 'Admin';
  const isCTO = currentUser?.role?.name === 'CTO';
  const isStrategyAnalyst = currentUser?.role?.name === 'Strategy Analyst';
  const isTOFinance = currentUser?.role?.name === 'TO Finance';

  // Only Admin has full access to everything
  const hasFullAccess = isAdmin;
  // Responsive state
  const [isMobile, setIsMobile] = useState(false);
  const [isTablet, setIsTablet] = useState(false);

  // Handle responsive breakpoints
  useEffect(() => {
    const handleResize = () => {
      const width = window.innerWidth;
      setIsMobile(width < 768);
      setIsTablet(width >= 768 && width < 1024);
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const handleBack = () => {
    if (filterHistory.length > 0) {
      const previousFilter = filterHistory.pop();
      setFilterHistory([...filterHistory]);
      if (previousFilter === 'Filter Options') {
        setCurrentFilter(null);
        setImpactCurrentFilter(null);
        setKpiCurrentFilter(null);
        setMilestoneCurrentFilter(null);
        setActionCurrentFilter(null);
        setInitiativeFilterType(null);
        setPeriodCurrentFilter(null);
      } else if (previousFilter === 'initiative') {
        setInitiativeFilterType('initiative');
        setCurrentFilter('initiative');
        setFilterVisible(false);
      } else if (previousFilter === 'impact') {
        setImpactCurrentFilter('impact');
      } else if (previousFilter === 'kpi') {
        setKpiCurrentFilter('kpi');
      } else if (previousFilter === 'milestone') {
        setMilestoneCurrentFilter('milestone');
      } else if (previousFilter === 'workstreamAction') {
        setActionCurrentFilter('workstreamAction');
      }
      else if (previousFilter === 'period') {
        setPeriodCurrentFilter('period');
      }
    }
  };

  const handleFilterChange = (filter) => {
    setFilterHistory([
      ...filterHistory,
      currentFilter ||
      impactCurrentFilter ||
      kpiCurrentFilter ||
      milestoneCurrentFilter ||
      actionCurrentFilter ||
      periodCurrentFilter ||
      'Filter Options',
    ]);
    if (filter === 'initiative') {
      setInitiativeFilterType('initiative');
      setCurrentFilter('initiative');
    } else if (filter === 'impact') {
      setImpactCurrentFilter('impact');
    } else if (filter === 'kpi') {
      setKpiCurrentFilter('kpi');
    } else if (filter === 'milestone') {
      setMilestoneCurrentFilter('milestone');
    } else if (filter === 'workstreamAction') {
      setActionCurrentFilter('workstreamAction');
    }
    else if (filter === 'period') {
      setPeriodCurrentFilter('period');
    }
    else {
      setCurrentFilter(filter);
    }
  };

  useEffect(() => {
    if (window.location.search === '?section=workbook' && workbookRef.current) {
      workbookRef.current.scrollTop = 0;
    }
  }, []);

  const [visibleColumns, setVisibleColumns] = useState(
    selectedInfoMenu === 'initiatives'
      ? initialColumns.map((col) => col.key)
      : selectedInfoMenu === 'milestones'
        ? milestoneInitialColumns.map((col) => col.key)
        : actionItemInitialColumn.map((col) => col.key)
  );

  const [allColumns, setAllColumns] = useState(
    selectedInfoMenu === 'initiatives'
      ? initialColumns
      : selectedInfoMenu === 'milestones'
        ? milestoneInitialColumns
        : actionItemInitialColumn
  );

  const handleMenuClick = (e) => {
    setSelectedMenu(menuItems.find((item) => item.key === e.key));
  };

  const menuItems = [
    { key: 'List', icon: <UnorderedListOutlined />, label: 'List View' },
    { key: 'Table', icon: <TableOutlined />, label: 'Table View' },
    { key: 'Pivot', icon: <AppstoreOutlined />, label: 'Pivot View' },
    { key: 'Gantt', icon: <CalendarOutlined />, label: 'Gantt Chart' },
    { key: 'Stacked', icon: <BarChartOutlined />, label: 'Stacked Chart' },
    { key: 'Multi-Measure', icon: <LineChartOutlined />, label: 'Multi-Measure Chart' },
    { key: 'Waterfall', icon: <FileTextOutlined />, label: 'Waterfall Chart' },
    { key: 'Note', icon: <FileDoneOutlined />, label: 'Note' },
  ];

  const handleInfoMenuClick = (key) => {
    // If Executive Assistant, only allow 'workstreamactions'
    if (isExecutiveAssistant && key !== 'workstreamactions') {
      return;
    }
    setSelectedInfoMenu(key);
  };
  useEffect(() => { }, [groupedInitiativesByHistory]);

  let finalInitiatives = {};
  if (selectedGroup === 'None') {
    finalInitiatives = groupedInitiativesByHistory;
  } else {
    finalInitiatives = groupedInitiatives;
  }

  const groupedData =
    selectedInfoMenu === 'initiatives'
      ? finalInitiatives
      : selectedInfoMenu === 'milestones'
        ? groupedMilestones
        : groupedActionItems;

  const dataToDownload =
    selectedInfoMenu === 'initiatives'
      ? filteredData
      : selectedInfoMenu === 'milestones'
        ? filteredMilestones
        : filteredActionItems;

  const finalDownloadData = dataToDownload;

  useEffect(() => {
    if (selectedInfoMenu === 'initiatives') {
      setAllColumns(initialColumns);
      setVisibleColumns(initialColumns.map((col) => col.key));
    } else if (selectedInfoMenu === 'milestones') {
      setAllColumns(milestoneInitialColumns);
      setVisibleColumns(milestoneInitialColumns.map((col) => col.key));
    } else if (selectedInfoMenu === 'workstreamactions') {
      setAllColumns(actionItemInitialColumn);
      setVisibleColumns(actionItemInitialColumn.map((col) => col.key));
    }
  }, [selectedInfoMenu]);

  // const fullAccessRoles = ['CTO', 'Admin', 'Strategy Analyst', 'TO Finance'];
const myWorkstreamActionData = useMemo(() => {
  // If currentUser is undefined, return empty array
  if (!filteredActionItems || !currentUser) {
    return [];
  }

  return filteredActionItems.filter((action) => {
    // Helper to check if user is the owner
    const isOwner = (() => {
      if (action?.owner) {
        if (typeof action.owner === 'object' && action.owner._id) {
          return action.owner._id.toString() === currentUser.id.toString();
        } else if (typeof action.owner === 'string') {
          return action.owner.toString() === currentUser.id.toString();
        } else if (typeof action.owner === 'object' && action.owner.id) {
          return action.owner.id.toString() === currentUser.id.toString();
        }
      }
      return false;
    })();

    // Helper to check if user is a collaborator
    const isCollaborator = action?.collaborator?.some((colla) => {
      if (!colla) return false;
      let collaId = null;
      if (typeof colla === 'object' && colla._id) {
        collaId = colla._id;
      } else if (typeof colla === 'object' && colla.id) {
        collaId = colla.id;
      } else if (typeof colla === 'string') {
        collaId = colla;
      }
      return collaId && collaId.toString() === currentUser.id.toString();
    });

    // If user has full access (Admin only)
    if (hasFullAccess) {
      // Admin can see everything
      return true;
    }

    // If user is Executive Assistant
    if (isExecutiveAssistant) {
      // Check if source is allowed
      const hasAllowedSource = EXECUTIVE_ASSISTANT_ALLOWED_SOURCES.includes(action?.source);

      // Show if user is owner, collaborator, OR has allowed source
      return isOwner || isCollaborator || hasAllowedSource;
    }

    // For restricted sources (AMC, CMC, EMC, Office of CEO)
    if (RESTRICTED_SOURCES.includes(action?.source)) {
      // Show only to Admin, Executive Assistant, Owner, or Collaborator
      // CTO, Strategy Analyst, and TO Finance cannot see restricted sources
      return isAdmin || isExecutiveAssistant || isOwner || isCollaborator;
    }

    // For non-restricted sources (TO, SteerCo)
    // CTO, Strategy Analyst, and TO Finance can see all non-restricted sources
    // They don't need workstream/subworkstream filtering for non-restricted sources
    const isCTOorStrategyAnalystorTOFinance = isCTO || isStrategyAnalyst || isTOFinance;
    
    if (isCTOorStrategyAnalystorTOFinance) {
      // They can see all non-restricted sources
      return true;
    }

    // For other users (non-CTO, non-Strategy Analyst, non-TO Finance)
    // Use workstream/subworkstream logic
    const ownerWorkstream =
      action?.owner?.workstream?._id === currentUser?.workstream?._id ||
      action?.owner?.subworkstream?.workstream?._id === currentUser?.subworkstream?.workstream?._id;
    const ownerSubworkstream =
      action?.subworkstream?._id === currentUser?.subworkstream?._id;

    const collaboratorWorkstreams = action?.collaborator?.some(
      (colla) =>
        colla?.workstream?._id === currentUser?.workstream?._id ||
        colla?.subworkstream?.workstream?._id === currentUser?.subworkstream?.workstream?._id
    );

    const collaboratorSubworkstreams = action?.collaborator?.some(
      (colla) =>
        colla?.subworkstream?._id === currentUser?.subworkstream?._id
    );

    return (
      ownerWorkstream ||
      ownerSubworkstream ||
      collaboratorWorkstreams ||
      collaboratorSubworkstreams
    );
  });
}, [filteredActionItems, currentUser, isExecutiveAssistant, isAdmin, hasFullAccess, isCTO, isStrategyAnalyst, isTOFinance]);
  const infoMenuItems = useMemo(() => {
    const items = [];

    if (isExecutiveAssistant) {
      // Executive Assistant only sees Workstream Actions
      items.push(
        <Menu.Item key="workstreamactions" icon={<ThunderboltOutlined />}>
          {myWorkstreamActionData.length} Workstream Actions
        </Menu.Item>
      );
    } else {
      // Regular users see all menu items
      items.push(
        <Menu.Item key="initiatives" icon={<RocketOutlined />}>
          {filteredData?.length} Initiatives
        </Menu.Item>,
        <Menu.Item key="milestones" icon={<CalendarOutlined />}>
          {filteredMilestones?.length} Milestones
        </Menu.Item>,
        <Menu.Item key="workstreamactions" icon={<ThunderboltOutlined />}>
          {myWorkstreamActionData.length} Workstream Actions
        </Menu.Item>,
        <Menu.Item key="users" icon={<UserOutlined />}>
          {users.length} Users
        </Menu.Item>
      );
    }

    return items;
  }, [isExecutiveAssistant, filteredData, filteredMilestones, myWorkstreamActionData, users]);
  const infoMenu = (
    <Menu
      onClick={(e) => handleInfoMenuClick(e.key)}
      style={{ margin: 0, border: 'none', boxShadow: 'none' }}
    >
      {infoMenuItems}
    </Menu>
  );

  const handleSortOrderChange = (e) => {
    setSortOrder(e.target.value);
  };

  const handleSortChange = (value) => {
    setSortField(value);
  };

  const onClose = () => {
    setIsModalOpen(false);
  }

  const exportToExcel = () => {
    // Determine which data to export based on the current view and filters
    let dataToExport = [];

    if (selectedInfoMenu === 'initiatives') {
      dataToExport = filteredData; // Use filteredData for initiatives
    } else if (selectedInfoMenu === 'milestones') {
      dataToExport = filteredMilestones; // Use filteredMilestones for milestones
    } else if (selectedInfoMenu === 'workstreamactions') {
      // For workstream actions, use the filtered data from the table
      // This should be the data that is currently displayed
      dataToExport = myWorkstreamActionData; // This already has user-specific filters applied
    }

    // If there's a filter applied, use the filtered data
    if (currentFilter || actionCurrentFilter || milestoneCurrentFilter || impactCurrentFilter) {
      // The data is already filtered in the parent component
      // Use the filtered data that's passed in
      if (selectedInfoMenu === 'initiatives') {
        dataToExport = filteredData;
      } else if (selectedInfoMenu === 'milestones') {
        dataToExport = filteredMilestones;
      } else if (selectedInfoMenu === 'workstreamactions') {
        dataToExport = myWorkstreamActionData;
      }
    }

    handleDownloadData(
      dataToExport,
      selectedInfoMenu,
      users,
      initiatives,
      subworkstream,
      historyData,
      selectedRange,
      selectedGroup,
      determineStage,
      calculateNetRecurringBenefit,
      calculateOneTimeBenefit,
      calculateOneTimeImplementationCost,
      L3PlanDate,
      L4PlanDate,
      InitiativePlanningSummary,
      checkWorkstreamLeadApprovalStatus,
      checkWorkstreamSponsorApprovalStatus,
      checkToFinanceApprovalStatus,
      getNetRecurringBenefitCategory,
      L2PlanDate,
      L5PlanDate,
      L0PlanDate,
      L1PlanDate,
      L2ActualDate,
      L3ActualDate,
      L4ActualDate,
      L5ActualDate,
      LLatestActualDate,
      SubmittedForL1PlanDate,
      SubmittedForL2PlanDate,
      SubmittedForL3PlanDate,
      SubmittedForL4PlanDate,
      SubmittedForL5PlanDate,
      getNetRecurringBenefitChangeCategoryL0Plus,
      getNetRecurringBenefitChangeCategoryL1Plus,
      getNetRecurringBenefitChangeCategoryL2Plus,
      getNetRecurringBenefitChangeCategoryL3Plus,
      getNetRecurringBenefitChangeCategoryL4Plus,
      getComplianceStatus,
      sortInitiativesByActuals,
      checkStrategyAnalystApprovalStatus,
      sortInitiativesByActualImpact,
      getImplementationCostCatagory,
      determinePlanningSummary,
      getMilestoneBinValue,
      initialColumns,
      visibleColumns,
      milestoneInitialColumns,
      selectedInfoMenu === 'milestones' ? visibleColumns : milestoneInitialColumns.map(col => col.key),
      actionItemInitialColumn,
      selectedInfoMenu === 'workstreamactions' ? visibleColumns : actionItemInitialColumn.map(col => col.key),
      subsectors
    );
  };
  const columnVisibilityContent = (
    <ColumnVisibileManager
      columns={allColumns}
      visibleColumns={visibleColumns}
      setVisibleColumns={setVisibleColumns}
      onClose={onClose}
    />
  );

  const handleToggleCollapseExpand = () => {
    setIsAllGroupsCollapsed(!isAllGroupsCollapsed);
  };

  useEffect(() => {
    if (groupedData && Object.keys(groupedData).length > 0) {
      if (!isAllGroupsCollapsed) {
        setExpandedKeys(Object.keys(groupedData));
      } else {
        setExpandedKeys([]);
      }
    }
  }, [isAllGroupsCollapsed, groupedData]);

  const periodAllowedAttributes = [
    'forecastImpactTotal',
    'leImpactTotal',
    'plannedImpactTotalExcl',
    'actualImpactTotalExcl',
    'forecastImpactTotalExcl',
    'leImpactTotalExcl',
    'actualImpactTotal',
    'plannedImpactTotal',
    'Total impact (total, ETB mn)',
    'plannedKPI',
    'plannedDepositKPI',
    'plannedLoanKPI',
    'plannedFinancingKPI',
    'plannedFCYKPI',
    'actualKPI',
    'actualDepositKPI',
    'actualLoanKPI',
    'actualFinancingKPI',
    'actualFCYKPI',
    'plannedAccount',
    'actualAccount'
  ];

  const isPeriodGroupAllowed = aggregatedAttributes.some((attr) =>
    periodAllowedAttributes.includes(attr)
  );

  const handleCloseWorkbook = () => {
    setSelectedGroup('None');
    setSelectedHistoryGroup([]);
    setSelectedRange([]);
    setColorByAttribute('None');
    setSortField(null);
    setSortOrder(null);
    setAggregatedAttributes([]);
    setSelectedImpactGroup('None');
    setSelectedDateRange(null);
    setSelectedFilters({});
    setAttributeFilters({});
    setSelectedDateRange(null);
    setGroupedMilestones({});
    setGroupedActionItems({});
    setGroupedInitiatives({});
    setCurrentFilter(null);
    setActionCurrentFilter(null);
    setMilestoneCurrentFilter(null);
    setImpactCurrentFilter(null);
    setPeriodCurrentFilter(null);
    setKpiCurrentFilter(null);
    setInitiativeFilterType(null);
    setGroupedImpact({});
    setGroupedInitiativesByHistory({});
    const menuKey = 'List';
    const menuIcon = <TableOutlined />;
    const menuLabel = 'List View';
    setSelectedMenu({
      key: menuKey,
      icon: menuIcon,
      label: menuLabel,
    });
  };

  const handleDropdownVisibleChange = (flag) => {
    setIsDropdownVisible(flag);
  };

  const workbookMenu = (
    <Menu>
      <Menu.Item key="open">
        <Button type="link" onClick={() => console.log('Open workbook clicked')}>
          Open workbook
        </Button>
      </Menu.Item>
      <Menu.Item key="save">
        <Button type="link" onClick={() => console.log('Save workbook clicked')}>
          Save workbook
        </Button>
      </Menu.Item>
      <Menu.Item key="share">
        <Button type="link" onClick={() => console.log('Share workbook clicked')}>
          Share workbook
        </Button>
      </Menu.Item>
      <Menu.Item key="close">
        <Button type="link" onClick={handleCloseWorkbook}>
          Close workbook
        </Button>
      </Menu.Item>
    </Menu>
  );
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  // Sidebar width - maintain original desktop layout, adjust only for mobile
  const sidebarWidth = isMobile ? (isMobile && !sidebarCollapsed ? '100%' : '0px') : '200px';
  const mainMarginLeft = isMobile ? 0 : '200px';
  const mainWidth = isMobile ? '100%' : 'calc(100% - 200px)';


  return (
    <div style={{ overflow: 'hidden', display: 'flex', flexDirection: isMobile ? 'column' : 'row' }}>
      {/* Mobile Menu Toggle Button - Only shows on mobile */}
      {isMobile && (
        <div style={{
          padding: '10px',
          backgroundColor: '#f5f5f5',
          borderBottom: '1px solid #e8e8e8',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          marginTop: '100px'
        }}>
          <Button
            onClick={() => setSidebarCollapsed(!sidebarCollapsed)}
            icon={sidebarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
          >
            Menu
          </Button>
          <Dropdown
            overlay={
              <Menu onClick={handleMenuClick}>
                {menuItems.map((item) => (
                  <Menu.Item key={item.key} icon={item.icon}>
                    {item.label}
                  </Menu.Item>
                ))}
              </Menu>
            }
            trigger={['click']}
          >
            <Button size="small">
              {selectedMenu.icon} {selectedMenu.label} <DownOutlined />
            </Button>
          </Dropdown>
        </div>
      )}

      {/* Left Sidebar - Original desktop layout, responsive for mobile */}
      <div
        ref={otherElementRef}
        id="otherElement"
        style={{
          width: sidebarWidth,
          flexShrink: 0,
          padding: isMobile ? (sidebarCollapsed ? 0 : '10px') : '10px',
          zIndex: 1,
          overflowY: 'auto',
          height: isMobile ? 'auto' : '100vh',
          display: (isMobile && sidebarCollapsed) ? 'none' : 'flex',
          flexDirection: 'column',
          position: isMobile ? 'relative' : 'fixed',
          borderRight: '1px solid #eee',
          backgroundColor: '#fff',
          transition: 'all 0.3s ease',
        }}
      >
        {/* Desktop view menu button */}
        {!isMobile && (
          <div style={{ marginBottom: '20px' }}>
            <Dropdown
              overlay={
                <Menu onClick={handleMenuClick}>
                  {menuItems.map((item) => (
                    <Menu.Item key={item.key} icon={item.icon}>
                      {item.label}
                    </Menu.Item>
                  ))}
                </Menu>
              }
              trigger={['click']}
            >
              <Button>
                {selectedMenu.icon} {selectedMenu.label} <DownOutlined />
              </Button>
            </Dropdown>
          </div>
        )}
        <div
          style={{
            padding: '10px',
            border: '1px solid #ddd',
            borderRadius: '5px',
            color: 'black',
            flexGrow: 1,
            overflowY: 'auto',
          }}
        >
          {infoMenu}
        </div>
      </div>

      {/* Main Content Area - Original desktop layout */}
      <div
        style={{
          float: 'left',
          width: mainWidth,
          padding: '10px',
          marginLeft: mainMarginLeft,
          display: 'flex',
          flexDirection: 'column',
          height: '100vh',
        }}
      >
        {/* Sticky Header - Original positioning */}
        <div
          style={{
            position: 'fixed',
            marginLeft: 0,
            zIndex: 2,
            backgroundColor: 'white',
            marginTop: '-10px',
            height: isMobile ? 'auto' : '75px',
            paddingRight: isMobile ? '0px' : '10px',
            width: isMobile ? '100%' : `calc(100% - 220px)`,
            left: isMobile ? 0 : 'auto',
            top: isMobile ? 0 : 'auto',
          }}
        >
          <div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                marginTop: isMobile ? '80px' : '20px',
                marginBottom: '10px',
              }}
            >
              <Dropdown
                overlay={workbookMenu}
                trigger={['contextMenu']}
                onVisibleChange={handleDropdownVisibleChange}
                visible={isDropdownVisible}
              >
                <Button>
                  <span style={{ color: 'blue' }}>Untitled</span>{' '}
                  <span style={{ color: 'orange' }}>[unsaved]</span>
                </Button>
              </Dropdown>
            </div>

            {/* Toolbar - Original layout with responsive wrap */}
            <div style={{
              marginLeft: isMobile ? '200px' : '1000px',
              marginTop: isMobile ? 0 : '-50px',
              overflowX: isMobile ? 'auto' : 'visible',
              whiteSpace: isMobile ? 'nowrap' : 'normal',
            }}>
              {/* First row of icons */}
              <Space style={{ marginBottom: 16, justifyContent: 'flex-end' }} size={isMobile ? 'small' : 'middle'}>
                {selectedMenu.key === 'Table' && (
                  <Tooltip title={'Apply different aggregation to the view '}>
                    <Button
                      size={isMobile ? 'small' : 'middle'}
                      icon={<DatabaseOutlined />}
                      onClick={() => {
                        setAggregationVisible(!aggregationVisible);
                        setColorVisible(false);
                        setGroupVisible(false);
                        setFilterVisible(false);
                        setSortVisible(false);
                        setCopyVisible(false);
                        setTableDownloadVisible(false);
                        setCardDetailVisible(false);
                        setSumVisible(false);
                        setTrackChangesVisible(false);
                        setSwapVisible(false);
                      }}
                    />
                  </Tooltip>
                )}
                <Tooltip
                  title={cardDetailVisible ? 'Hide Card Detail Panel' : 'Show Card Detail Panel'}
                >
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={cardDetailVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
                    onClick={() => {
                      setCardDetailVisible(!cardDetailVisible);
                      setAggregationVisible(false);
                      setColorVisible(false);
                      setGroupVisible(false);
                      setFilterVisible(false);
                      setSortVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
                <Tooltip title={'Group the content of view by selected field values'}>
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={<GroupOutlined />}
                    onClick={() => {
                      setGroupVisible(!groupVisible);
                      setAggregationVisible(false);
                      setColorVisible(false);
                      setFilterVisible(false);
                      setSortVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setCardDetailVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
                <Tooltip title={'Color the content of view by selected field values'}>
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={<BgColorsOutlined />}
                    onClick={() => {
                      setColorVisible(!colorVisible);
                      setAggregationVisible(false);
                      setGroupVisible(false);
                      setFilterVisible(false);
                      setSortVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setCardDetailVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
                <Tooltip title={'Sort the content of view by selected field values'}>
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={<SortAscendingOutlined />}
                    onClick={() => {
                      setSortVisible(!sortVisible);
                      setAggregationVisible(false);
                      setColorVisible(false);
                      setGroupVisible(false);
                      setFilterVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setCardDetailVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
                <Tooltip title={'Filter the view'}>
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={<FilterOutlined />}
                    onClick={() => {
                      setFilterVisible(!filterVisible);
                      setAggregationVisible(false);
                      setColorVisible(false);
                      setGroupVisible(false);
                      setSortVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setCardDetailVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
                <Tooltip title={trackChangesVisible ? 'Stop Tracking Changes' : 'Track Changes'}>
                  <Button
                    size={isMobile ? 'small' : 'middle'}
                    icon={<HistoryOutlined />}
                    onClick={() => {
                      setTrackChangesVisible(!trackChangesVisible);
                      setFilterVisible(false);
                      setAggregationVisible(false);
                      setColorVisible(false);
                      setGroupVisible(false);
                      setSortVisible(false);
                      setCopyVisible(false);
                      setTableDownloadVisible(false);
                      setSumVisible(false);
                      setTrackChangesVisible(false);
                      setSwapVisible(false);
                    }}
                  />
                </Tooltip>
              </Space>

              {/* Divider - hidden on mobile for better spacing */}
              {!isMobile && <Divider style={{ marginTop: '-35px' }} />}

              {/* Second row of icons */}
              <Space style={{ marginBottom: 10, justifyContent: 'flex-end' }} size={isMobile ? 'small' : 'middle'}>
                {selectedMenu.key === 'List' && (
                  <>
                    <Tooltip title={isAllGroupsCollapsed ? 'Expand All Groups' : 'Collapse All Groups'}>
                      <Button
                        size={isMobile ? 'small' : 'middle'}
                        icon={<MenuFoldOutlined onClick={handleToggleCollapseExpand} />}
                        disabled={selectedGroup === 'None'}
                      />
                    </Tooltip>
                    <Popover
                      content={columnVisibilityContent}
                      title="Configure column visibility and order"
                      trigger="click"
                      open={isModalOpen}
                      onOpenChange={(visible) => setIsModalOpen(visible)}
                    >
                      <Button size={isMobile ? 'small' : 'middle'} icon={<SettingOutlined />} onClick={() => setIsModalOpen(true)} />
                    </Popover>
                  </>
                )}
                {selectedMenu.key === 'Table' && (
                  <>
                    <Tooltip title={'Expand and Collapse Grouping'}>
                      <Button
                        size={isMobile ? 'small' : 'middle'}
                        icon={isAllGroupsExpanded ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                        onClick={() => setIsAllGroupsExpanded(!isAllGroupsExpanded)}
                        disabled={colorByAttribute === 'None' || colorByAttribute === null}
                      />
                    </Tooltip>
                    <Tooltip title={'Show total'}>
                      <Button
                        size={isMobile ? 'small' : 'middle'}
                        onClick={() => {
                          setSumVisible(!sumVisible);
                          setFilterVisible(false);
                          setAggregationVisible(false);
                          setColorVisible(false);
                          setGroupVisible(false);
                          setSortVisible(false);
                          setCopyVisible(false);
                          setTableDownloadVisible(false);
                          setCardDetailVisible(false);
                          setTrackChangesVisible(false);
                        }}
                      >
                        ∑
                      </Button>
                    </Tooltip>
                    <Tooltip title={'Swap rows and columns over'}>
                      <Button
                        size={isMobile ? 'small' : 'middle'}
                        icon={<RotateRightOutlined />}
                        onClick={() => {
                          setSwapVisible(!swapVisible);
                          setFilterVisible(false);
                          setAggregationVisible(false);
                          setColorVisible(false);
                          setGroupVisible(false);
                          setSortVisible(false);
                          setCopyVisible(false);
                          setTableDownloadVisible(false);
                          setCardDetailVisible(false);
                          setSumVisible(true);
                          setTrackChangesVisible(false);
                        }}
                      />
                    </Tooltip>
                  </>
                )}
                <Tooltip title={'Export tab as an excel file'}>
                  {selectedMenu.key === 'List' ? (
                    <Button size={isMobile ? 'small' : 'middle'} icon={<DownloadOutlined />} onClick={exportToExcel} />
                  ) : (
                    <Button
                      size={isMobile ? 'small' : 'middle'}
                      icon={<DownloadOutlined />}
                      onClick={() => setTableDownloadVisible(!tableDownloadVisible)}
                    />
                  )}
                </Tooltip>
                <Tooltip title={'Copy the list to your clipboard'}>
                  <Button size={isMobile ? 'small' : 'middle'} icon={<CopyOutlined onClick={() => setCopyVisible(!copyVisible)} />} />
                </Tooltip>
              </Space>
            </div>
          </div>
        </div>

        {/* Render View Area - Original scrolling behavior */}
        <div
          ref={workbookRef}
          style={{
            flexGrow: 1,
            overflowY: 'auto',
            overflowX: 'auto',
            position: 'relative',
            paddingTop: isMobile ? 0 : '16px',
            marginTop: isMobile ? 0 : '40px',
          }}
        >
          <div style={{ position: 'relative' }}>
            {(selectedGroup || selectedHistoryGroup) && Object.keys(groupedData).length > 0 && selectedMenu.key === 'List' ? (
              <Collapse
                style={{ marginTop: isMobile ? '10px' : '50px' }}
                activeKey={expandedKeys}
                onChange={setExpandedKeys}
              >
                {Object.entries(groupedData).map(([groupValue, group]) => (
                  <Collapse.Panel header={`${groupValue} (${group.length})`} key={groupValue}>
                    <RenderView
                      searchResults={searchResults}
                      selectedInfoMenu={selectedInfoMenu}
                      initiatives={selectedInfoMenu === 'initiatives' ? group : filteredData}
                      milestones={selectedInfoMenu === 'milestones' ? group : filteredMilestones}
                      users={users}
                      actionItem={selectedInfoMenu === 'workstreamactions' ? group : myWorkstreamActionData}
                      selectedMenu={selectedMenu}
                      otherElementRef={otherElementRef}
                      initiativeColors={initiativeColors}
                      colorByAttribute={colorByAttribute}
                      milestoneColors={milestoneColors}
                      actionItemColors={actionItemColors}
                      aggregationAttribute={aggregatedAttributes}
                      swapVisible={swapVisible}
                      selectedMetric={selectedMetric}
                      sumVisible={sumVisible}
                      tableDownloadVisible={tableDownloadVisible}
                      setTableDownloadVisible={setTableDownloadVisible}
                      setCopyVisible={setCardDetailVisible}
                      copyVisible={copyVisible}
                      groupedImpact={groupedImpact}
                      groupedData={groupedInitiatives}
                      selectedImpactGroup={selectedImpactGroup}
                      selectedTimePeriod={selectedTimePeriod}
                      selectedDateRange={selectedDateRange}
                      visibleColumns={visibleColumns}
                      setCurrentFilter={setCurrentFilter}
                      setFilterVisible={setFilterVisible}
                      currentFilter={currentFilter}
                      setFilterHistory={setFilterHistory}
                      setMilestoneCurrentFilter={setMilestoneCurrentFilter}
                      milestoneCurrentFilter={milestoneCurrentFilter}
                      setActionItemCurrentFilter={setActionCurrentFilter}
                      actionItemCurrentFilter={actionCurrentFilter}
                      selectedGroup={selectedGroup}
                      xAxis={xAxis}
                      setXAxis={setXAxis}
                      yAxis={yAxis}
                      setYAxis={setYAxis}
                      attributeFilters={attributeFilters}
                      setSelectedImpactGroup={setSelectedImpactGroup}
                      isAllGroupsExpanded={isAllGroupsExpanded}
                      setIsAllGroupsExpanded={setIsAllGroupsExpanded}
                      sectors={subsectors}
                      sortField={sortField}
                      sortOrder={sortOrder}
                    />
                  </Collapse.Panel>
                ))}
              </Collapse>
            ) : (
              <RenderView
                searchResults={searchResults}
                selectedInfoMenu={selectedInfoMenu}
                initiatives={filteredData}
                milestones={filteredMilestones}
                users={users}
                actionItem={myWorkstreamActionData}
                selectedMenu={selectedMenu}
                otherElementRef={otherElementRef}
                initiativeColors={initiativeColors}
                colorByAttribute={colorByAttribute}
                milestoneColors={milestoneColors}
                actionItemColors={actionItemColors}
                aggregationAttribute={aggregatedAttributes}
                swapVisible={swapVisible}
                selectedMetric={selectedMetric}
                sumVisible={sumVisible}
                tableDownloadVisible={tableDownloadVisible}
                setTableDownloadVisible={setTableDownloadVisible}
                setCopyVisible={setCardDetailVisible}
                copyVisible={copyVisible}
                groupedImpact={groupedImpact}
                groupedData={groupedInitiatives}
                selectedImpactGroup={selectedImpactGroup}
                selectedTimePeriod={selectedTimePeriod}
                selectedDateRange={selectedDateRange}
                visibleColumns={visibleColumns}
                setCurrentFilter={setCurrentFilter}
                setFilterVisible={setFilterVisible}
                setFilterHistory={setFilterHistory}
                setMilestoneCurrentFilter={setMilestoneCurrentFilter}
                milestoneCurrentFilter={milestoneCurrentFilter}
                setActionItemCurrentFilter={setActionCurrentFilter}
                actionItemCurrentFilter={actionCurrentFilter}
                selectedGroup={selectedGroup}
                xAxis={xAxis}
                setXAxis={setXAxis}
                yAxis={yAxis}
                setYAxis={setYAxis}
                attributeFilters={attributeFilters}
                setSelectedImpactGroup={setSelectedImpactGroup}
                isAllGroupsExpanded={isAllGroupsExpanded}
                setIsAllGroupsExpanded={setIsAllGroupsExpanded}
                sectors={subsectors}
                sortField={sortField}
                sortOrder={sortOrder}
              />
            )}
          </div>
        </div>

        {/* Popup panels - responsive positioning */}
        {aggregationVisible && (
          <div
            style={{
              position: 'fixed',
              top: isMobile ? 200 : 150,
              right: isMobile ? 10 : 'auto',
              left: isMobile ? 'auto' : 1350,
              transform: isMobile ? 'none' : 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '5px',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              width: isMobile ? 'calc(100% - 20px)' : '300px',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '10px',
            }}
          >
            <AggregateContent
              aggregatedAttributes={aggregatedAttributes}
              setAggregatedAttributes={setAggregatedAttributes}
              selectedMenu={selectedMenu.key}
            />
          </div>
        )}

        {groupVisible && (
          <div
            style={{
              position: 'fixed',
              top: isMobile ? 200 : 150,
              right: isMobile ? 10 : 'auto',
              left: isMobile ? 'auto' : 1350,
              transform: isMobile ? 'none' : 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '5px',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              width: isMobile ? 'calc(100% - 300px)' : '300px',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '10px',
            }}
          >
            {!groupingFilter && (selectedMenu.key === 'List' || selectedMenu.key === 'Waterfall' || selectedMenu.key === 'Stacked' || selectedMenu.key === 'Table') && (
              <div>
                <div
                  onClick={() => setGroupingFilter('initiative')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Group by Initiative &gt;
                </div>
                {(selectedMenu.key === 'List' || selectedMenu.key === 'Waterfall' || selectedMenu.key === 'Table') && (
                  <div
                    onClick={() => setGroupingFilter('milestone')}
                    style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                  >
                    Group by Milestone &gt;
                  </div>
                )}
                {(selectedMenu.key === 'Table' || selectedMenu.key === 'Waterfall' || selectedMenu.key === 'Stacked') && (
                  <>
                    <div
                      onClick={() => {
                        if (!aggregatedAttributes.includes('initiativeCount')) {
                          setGroupingFilter('impact');
                        }
                      }}
                      style={{
                        cursor: aggregatedAttributes.includes('initiativeCount') ? 'not-allowed' : 'pointer',
                        marginBottom: 10,
                        color: aggregatedAttributes.includes('initiativeCount') ? 'gray' : 'black',
                        pointerEvents: aggregatedAttributes.includes('initiativeCount') ? 'none' : 'auto',
                      }}
                    >
                      Group by Impact &gt;
                    </div>
                    <div
                      onClick={() => {
                        if (isPeriodGroupAllowed) {
                          setGroupingFilter('period');
                        }
                      }}
                      style={{
                        cursor: isPeriodGroupAllowed ? 'pointer' : 'not-allowed',
                        marginBottom: 10,
                        color: isPeriodGroupAllowed ? 'black' : 'gray',
                        pointerEvents: isPeriodGroupAllowed ? 'auto' : 'none',
                      }}
                    >
                      Group by Period &gt;
                    </div>
                  </>
                )}
                {selectedMenu.key === 'List' && (
                  <div
                    onClick={() => setGroupingFilter('workstreamAction')}
                    style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                  >
                    Group by Workstream Action &gt;
                  </div>
                )}
                {selectedMenu.key === 'Table' && (
                  <div
                    onClick={() => setGroupingFilter('history')}
                    style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                  >
                    Group by History &gt;
                  </div>
                )}
              </div>
            )}
            {groupingFilter && (
              <div>
                <div
                  onClick={() => setGroupingFilter(null)}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'blue' }}
                >
                  &lt; Back
                </div>
                {groupingFilter === 'initiative' && (
                  <GroupContent selectedGroup={selectedGroup} setSelectedGroup={setSelectedGroup} />
                )}
                {groupingFilter === 'milestone' && (
                  <MilestoneGroupContent
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                  />
                )}
                {groupingFilter === 'workstreamAction' && (
                  <WorkstreamActionGroupContent
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                  />
                )}
                {groupingFilter === 'period' && !aggregatedAttributes.includes('initiativeCount') && (
                  <PeriodGroupContent
                    selectedGroup={selectedImpactGroup}
                    setSelectedGroup={setSelectedImpactGroup}
                    selectedTimePeriod={selectedTimePeriod}
                    setSelectedTimePeriod={setSelectedTimePeriod}
                    selectedDateRange={selectedDateRange}
                    setSelectedDateRange={setSelectedDateRange}
                  />
                )}
                {groupingFilter === 'impact' && !aggregatedAttributes.includes('initiativeCount') && (
                  <ImpactGroupContent
                    selectedGroup={selectedGroup}
                    setSelectedGroup={setSelectedGroup}
                  />
                )}
                {groupingFilter === 'history' && (
                  <HistoryGroupContent
                    initiatives={filteredData}
                    isGroupingEnabled={isGroupingEnabled}
                    onGroupingEnabledChange={setIsGroupingEnabled}
                    selectedGroup={selectedHistoryGroup}
                    setSelectedGroup={setSelectedHistoryGroup}
                    selectedRange={selectedRange}
                    setSelectedRange={setSelectedRange}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {sortVisible && (
          <div
            style={{
              position: 'fixed',
              top: isMobile ? 200 : 150,
              right: isMobile ? 10 : 'auto',
              left: isMobile ? 'auto' : 1350,
              transform: isMobile ? 'none' : 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '5px',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              width: isMobile ? 'calc(100% - 300px)' : '300px',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '10px',
            }}
          >
            {!sortFilter && selectedMenu.key === 'List' && (
              <div>
                <div
                  onClick={() => setSortFilter('initiative')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Sort by Initiative &gt;
                </div>
                <div
                  onClick={() => setSortFilter('milestone')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Sort by Milestone &gt;
                </div>
                <div
                  onClick={() => setSortFilter('workstreamAction')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Sort by Workstream Action &gt;
                </div>
              </div>
            )}
            {!sortFilter && colorByAttribute && selectedMenu.key === 'Table' && (
              <div>
                <div
                  onClick={() => setSortFilter('colors')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Sort colors &gt;
                </div>
              </div>
            )}
            {sortFilter && (
              <div>
                <div
                  onClick={() => setSortFilter(null)}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'blue' }}
                >
                  &lt; Back
                </div>
                {sortFilter === 'initiative' && (
                  <SortContent
                    sortOrder={sortOrder}
                    sortField={sortField}
                    handleSortOrderChange={handleSortOrderChange}
                    handleSortChange={handleSortChange}
                    selectedMenu={selectedMenu.key}
                    colorByAttribute={colorByAttribute}
                  />
                )}
                {sortFilter === 'colors' && (
                  <SortContent
                    sortOrder={sortOrder}
                    sortField={sortField}
                    handleSortOrderChange={handleSortOrderChange}
                    handleSortChange={handleSortChange}
                    selectedMenu={selectedMenu.key}
                    colorByAttribute={colorByAttribute}
                  />
                )}
                {sortFilter === 'milestone' && (
                  <MilestoneSortContent
                    sortOrder={sortOrder}
                    sortField={sortField}
                    handleSortOrderChange={handleSortOrderChange}
                    handleSortChange={handleSortChange}
                  />
                )}
                {sortFilter === 'workstreamAction' && (
                  <WorkstreamActionSortContent
                    sortOrder={sortOrder}
                    sortField={sortField}
                    handleSortOrderChange={handleSortOrderChange}
                    handleSortChange={handleSortChange}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {colorVisible && (
          <div
            style={{
              position: 'fixed',
              top: isMobile ? 200 : 150,
              right: isMobile ? 10 : 'auto',
              left: isMobile ? 'auto' : 1350,
              transform: isMobile ? 'none' : 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '5px',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              width: isMobile ? 'calc(100% - 300px)' : '300px',
              maxHeight: '80vh',
              overflowY: 'auto',
              padding: '10px',
            }}
          >
            {!colorFilter && (selectedMenu.key === 'List' || selectedMenu.key === 'Waterfall') && (
              <div>
                <div
                  onClick={() => setColorFilter('initiative')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Initiative &gt;
                </div>
                <div
                  onClick={() => setColorFilter('milestone')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Milestone &gt;
                </div>
                <div
                  onClick={() => setColorFilter('workstreamAction')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Workstream Action &gt;
                </div>
              </div>
            )}
            {!colorFilter && selectedMenu.key === 'Table' && (
              <div>
                <div
                  onClick={() => setColorFilter('initiative')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Initiative &gt;
                </div>
                <div
                  onClick={() => setColorFilter('milestone')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Milestone &gt;
                </div>
                <div
                  onClick={() => setColorFilter('workstreamAction')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Workstream Action &gt;
                </div>
                <div
                  onClick={() => setColorFilter('impact')}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'black' }}
                >
                  Color by Impact &gt;
                </div>
              </div>
            )}
            {colorFilter && (
              <div>
                <div
                  onClick={() => setColorFilter(null)}
                  style={{ cursor: 'pointer', marginBottom: 10, color: 'blue' }}
                >
                  &lt; Back
                </div>
                {colorFilter === 'initiative' && (
                  <ColorContent
                    colorByAttribute={colorByAttribute}
                    setColorByAttribute={setColorByAttribute}
                    selectedMenu={selectedMenu}
                  />
                )}
                {colorFilter === 'milestone' && (
                  <MilestoneColorContent
                    colorByAttribute={colorByAttribute}
                    setColorByAttribute={setColorByAttribute}
                    selectedMenu={selectedMenu}
                  />
                )}
                {colorFilter === 'workstreamAction' && (
                  <WorkstreamActionColorContent
                    colorByAttribute={colorByAttribute}
                    setColorByAttribute={setColorByAttribute}
                    selectedMenu={selectedMenu}
                  />
                )}
                {colorFilter === 'impact' && (
                  <ImpactColorContent
                    colorByAttribute={colorByAttribute}
                    setColorByAttribute={setColorByAttribute}
                  />
                )}
              </div>
            )}
          </div>
        )}

        {filterVisible && (
          <div
            style={{
              position: 'fixed',
              top: isMobile ? 200 : 150,
              right: isMobile ? 10 : 'auto',
              left: isMobile ? 'auto' : 1350,
              transform: isMobile ? 'none' : 'translateX(-50%)',
              backgroundColor: 'white',
              border: '1px solid #ddd',
              borderRadius: '5px',
              color: 'black',
              zIndex: 10,
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
              width: isMobile ? 'calc(100% - 300px)' : '300px',
              maxHeight: '80vh',
              overflowY: 'auto',
            }}
          >
            {initiativeFilterType ||
              currentFilter ||
              impactCurrentFilter ||
              kpiCurrentFilter ||
              milestoneCurrentFilter ||
              periodCurrentFilter ||
              actionCurrentFilter ? (
              <>
                <Button icon={<LeftOutlined />} onClick={handleBack} style={{ marginBottom: 16 }} />
                <AttributeFilters
                  type={
                    currentFilter ||
                    impactCurrentFilter ||
                    kpiCurrentFilter ||
                    milestoneCurrentFilter ||
                    actionCurrentFilter ||
                    periodCurrentFilter ||
                    initiativeFilterType
                  }
                  initiatives={initiatives}
                  actionItem={actionItem}
                  currentFilter={currentFilter}
                  setCurrentFilter={setCurrentFilter}
                  impactCurrentFilter={impactCurrentFilter}
                  setImpactCurrentFilter={setImpactCurrentFilter}
                  kpiCurrentFilter={kpiCurrentFilter}
                  setKpiCurrentFilter={setKpiCurrentFilter}
                  milestoneCurrentFilter={milestoneCurrentFilter}
                  setMilestoneCurrentFilter={setMilestoneCurrentFilter}
                  periodCurrentFilter={periodCurrentFilter}
                  setPeriodCurrentFilter={setPeriodCurrentFilter}
                  actionCurrentFilter={actionCurrentFilter}
                  setActionCurrentFilter={setActionCurrentFilter}
                  setInitiativeFilterType={setInitiativeFilterType}
                  attributeFilters={attributeFilters}
                  setAttributeFilters={setAttributeFilters}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                  users={users}
                  workstreams={subworkstream}
                  filterHistory={filterHistory}
                  setFilterHistory={setFilterHistory}
                  subsectors={subsectors}
                />
              </>
            ) : (
              <FilterContent
                handleFilterChange={handleFilterChange}
                aggregationAttribute={aggregatedAttributes}
              />
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Workbook;